// store/thunks/auth/sendEmailCodeThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { VerificationDTO } from '@/types/DTOs';

export const sendEmailCodeThunk = createAppAsyncThunk<
  VerificationDTO,
  undefined,
  { rejectValue: { message: string } }
>(
  'auth/sendEmailCode',
  async(_, { extra: { authService }, rejectWithValue }) => {
    try {
      return await authService.sendEmailCode();
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to send email code';
      return rejectWithValue({ message });
    }
  }
);
